<div class="spinner">
    <div class="spinner-bar-container">
        <div class="spinner-bar spinner-bar-3_2"></div>
    </div>
    <div class="spinner-bar-container">
        <div class="spinner-bar spinner-bar-1_1"></div>
    </div>
    <div class="spinner-bar-container">
        <div class="spinner-bar spinner-bar-1_2"></div>
    </div>
    <div class="spinner-bar-container">
        <div class="spinner-bar spinner-bar-1_4"></div>
    </div>
    <div class="spinner-bar-container">
        <div class="spinner-bar spinner-bar-1_8"></div>
    </div>
</div>
